export default __webpack_public_path__ + "static/media/learose4-2048w.1cfddf4d.avif";